// import React, { useEffect, useRef, useState } from "react";
// import {
//   Avatar,
//   Button,
//   Chip,
//   Textarea,
//   Popover,
//   PopoverContent,
//   PopoverTrigger,
// } from "@nextui-org/react";
// import { useDispatch, useSelector } from "react-redux";
// import { refreshIfNeeded } from "../store/actions/refreshIfNeeded";

// import { ImAttachment } from "react-icons/im";
// import { io } from "socket.io-client";
// import { displayTime, formatFileSize } from "../utils";
// import { FaFile } from "react-icons/fa6";
// import { BiSolidPaperPlane } from "react-icons/bi";
// import { IoMdChatbubbles, IoMdClose } from "react-icons/io";

// const isImageFile = (fileName, dataUrl) =>
//   (fileName && /\.(jpe?g|png|gif|bmp|webp|svg)$/i.test(fileName)) ||
//   (dataUrl && dataUrl.startsWith("data:image"));

// const ChatBox = ({ quoteId }) => {
//   // const accessToken = localStorage.getItem("accessToken");
//   const dispatch = useDispatch();
// const role = localStorage.getItem("role"); // role can stay as-is
// const accessToken = localStorage.getItem("accessToken")
// console.log("----------------------accesstoken redux----------------->" , accessToken);
//   /* ---------------- state ---------------- */
//   const [socket, setSocket] = useState(null);
//   const [isChatOpen, setIsChatOpen] = useState(false);
//   const [prevMessages, setPrevMessages] = useState([]);
//   const [newMessage, setNewMessage] = useState("");
//   const [fileToUpload, setFileToUpload] = useState(""); // base64 body
//   const [uploadedFile, setUploadedFile] = useState(null); // local preview
//   const [imgFailed, setImgFailed] = useState({}); // { msgId: true }
 
//   const scrollRef = useRef(null);

//   /* ---------------- socket setup ---------------- */
//  useEffect(() => {
//     if (!quoteId) return;

//     let socketInstance = null;

//     const initSocket = async () => {
//       // 1️⃣ Ensure fresh token before connect
//       await dispatch(refreshIfNeeded());
//       const token = localStorage.getItem("accessToken");
//       if (!token) return console.warn("⚠️ No access token, cannot connect socket");

//       // 2️⃣ Create socket
//       socketInstance = io(`${process.env.REACT_APP_SOCKET_SERVER_URL}/chats/${quoteId}`, {
//         auth: { token },
//         reconnection: false,
//       });

//       // 3️⃣ Bind events
//       socketInstance.on("connect", () => console.log("🟢 Socket connected:", socketInstance.id));
//       socketInstance.on("disconnect", (reason) => console.log("🔴 Socket disconnected:", reason));

//       socketInstance.on("previous chat", (msgs) => setPrevMessages(msgs));
//       socketInstance.on("chat message", (m) => setPrevMessages((p) => [...p, m]));
//       socketInstance.on("file upload", (m) => setPrevMessages((p) => [...p, m]));

//       socketInstance.on("connect_error", async (err) => {
//         if (err.message.includes("Authentication failed") || err.message.includes("Token has expired")) {
//           console.warn("⏳ Token invalid, reconnecting with fresh token...");
//           socketInstance.disconnect();
//           await initSocket();
//         }
//       });

//       setSocket(socketInstance);
//     };

//     initSocket();

//     return () => socketInstance?.disconnect();
//   }, [quoteId, dispatch]);

//   const handleSendMessage = (e) => {
//     e.preventDefault();
//     if (!socket) return;

//     if (newMessage.trim()) {
//       socket.emit("chat message", { quoteId, notes: newMessage, group: "CHATS", user_type: role });
//       setNewMessage("");
//     }

//     if (fileToUpload && uploadedFile) {
//       socket.emit("file upload", {
//         attachments: fileToUpload,
//         attachments_url: uploadedFile.filePath,
//         fileName: uploadedFile.fileName,
//         fileSize: uploadedFile.fileSize,
//       });
//       setFileToUpload("");
//       setUploadedFile(null);
//     }
//   };

//   /* ---------------- always scroll to bottom ---------------- */
//   useEffect(() => {
//     scrollRef.current?.scrollIntoView({ behavior: "smooth" });
//   }, [prevMessages]);

// //   /* ---------------- send message / file ---------------- */
// //   const handleSendMessage = (e) => {
// //     e.preventDefault();

// //     if (newMessage.trim()) {
// //     socket.emit("chat message", {
// //   quoteId,
// //   notes: newMessage,
// //   group: "CHATS",
// //   user_type: role,
// // });

// //       setNewMessage("");
// //     }

// //     if (fileToUpload && uploadedFile) {
// //       socket.emit("file upload", {
// //         attachments: fileToUpload,
// //         attachments_url: uploadedFile.filePath,
// //         fileName: uploadedFile.fileName,
// //         fileSize: uploadedFile.fileSize,
// //       });
// //       setFileToUpload("");
// //       setUploadedFile(null);
// //     }
// //   };

// //   /* ---------------- handle file select ---------------- */
//   const handleUpload = (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     const maxSize = 5 * 1024 * 1024; // 5 MB
//     if (file.size > maxSize) {
//       alert("Max 5 MB allowed");
//       return (e.target.value = null);
//     }

//     const reader = new FileReader();
//     reader.onload = (evt) =>
//       setUploadedFile({
//         fileName: file.name,
//         fileSize: file.size,
//         filePath: evt.target.result,
//       });
//     reader.onloadend = () => setFileToUpload(reader.result.split(",")[1]);
//     reader.readAsDataURL(file);
//   };

//   /* ---------------- key handler (enter to send) ---------------- */
//   const handleKeyDown = (e) => {
//     if (e.key === "Enter" && !e.shiftKey) handleSendMessage(e);
//     if (e.key === "Enter" && e.shiftKey) setNewMessage((t) => t + "\n");
//   };

//   return (
//     <div className="fixed bottom-20 sm:bottom-6 right-4 z-[999]">
//       <Popover
//         isOpen={isChatOpen}
//         shouldBlockScroll
//         shouldFlip={false}
//         onOpenChange={setIsChatOpen}
//       >
//         {/* ------------- floating button ------------- */}
//         <PopoverTrigger>
//           <Button
//             isIconOnly
//             size="lg"
//             className="bg-orange-100 text-orange-400 drop-shadow-md sm:drop-shadow-lg transition-transform duration-300 hover:scale-105 sm:hover:scale-110"
//           >
//             {isChatOpen ? (
//               <IoMdClose className="text-4xl" />
//             ) : (
//               <IoMdChatbubbles className="text-3xl" />
//             )}
//           </Button>
//         </PopoverTrigger>

//         {/* ------------- chat panel ------------- */}
//         <PopoverContent>
//           <div className="w-[17rem] sm:w-96 py-2 rounded-lg max-w-lg ml-auto overflow-hidden">
//             <h4 className="mb-4 font-semibold px-5">Direct messages</h4>

//             {/* messages list */}
//             <div className="px-5 py-6 grid bg-[#f2f3f5] max-h-[400px] overflow-y-auto">
//               {prevMessages.map((item) => (
//                 <div
//                   key={item.id}
//                   ref={scrollRef}
//                   className={`flex gap-3 ${
//                     item.user_type === role ? "justify-end" : ""
//                   } mb-5`}
//                 >
//                   <div
//                     className={`px-2.5 py-2 rounded-lg ${
//                       item.user_type === role
//                         ? "rounded-tr-none bg-white"
//                         : "rounded-tl-none bg-gray-200"
//                     }`}
//                   >
//                     {/* attachment (if any) */}
//                     {item.attachments_url && (
//                       <div className="mb-2 max-w-[250px]">
//                         {!imgFailed[item.id] ? (
//                           <a
//                             href={item.attachments_url}
//                             target="_blank"
//                             rel="noreferrer"
//                           >
//                             <img
//                               src={item.attachments_url}
//                               alt={item.fileName || "attachment"}
//                               className="rounded-md object-contain"
//                               onError={() =>
//                                 setImgFailed((p) => ({
//                                   ...p,
//                                   [item.id]: true,
//                                 }))
//                               }
//                             />
//                           </a>
//                         ) : (
//                           <a
//                             href={item.attachments_url}
//                             target="_blank"
//                             rel="noreferrer"
//                             className="inline-flex items-center gap-1 px-2 py-1 text-sm bg-slate-200 rounded hover:bg-slate-300"
//                           >
//                             <FaFile className="text-base" />
//                             Download file
//                           </a>
//                         )}
//                       </div>
//                     )}

//                     {/* message text */}
//                     {item.notes && <p>{item.notes}</p>}
//                     <p className="text-right text-sm text-slate-500/90">
//                       <sub>{displayTime(item.createdAt)}</sub>
//                     </p>
//                   </div>

//                   {/* avatar (other side only) */}
//                   <Avatar
//                     className={`rounded-full ${
//                       item.user_type === role ? "hidden" : "order-[-1]"
//                     }`}
//                   />
//                 </div>
//               ))}
//             </div>

//             {/* input box + actions */}
//             <form onSubmit={handleSendMessage}>
//               <div className="bg-[#f2f3f5] mt-2 py-3 px-2">
//                 {/* local preview (if any) */}
//                 {uploadedFile && (
//                   <div className="mb-3">
//                     <Chip
//                       radius="md"
//                       className="px-3 py-7 bg-slate-50"
//                       classNames={{
//                         content: "p-0",
//                         closeButton: "ml-5",
//                       }}
//                       onClose={() => setUploadedFile(null)}
//                     >
//                       <div className="flex gap-3">
//                         <div className="w-12 h-12 rounded-md overflow-hidden flex items-center justify-center bg-white">
//                           {isImageFile(
//                             uploadedFile.fileName,
//                             uploadedFile.filePath
//                           ) ? (
//                             <img
//                               src={uploadedFile.filePath}
//                               alt="preview"
//                               className="w-full h-full object-cover"
//                             />
//                           ) : (
//                             <FaFile className="text-2xl text-slate-700" />
//                           )}
//                         </div>
//                         <div>
//                           <p className="text-xs font-semibold">
//                             {uploadedFile.fileName}
//                           </p>
//                           <span className="text-xs">
//                             {formatFileSize(uploadedFile.fileSize)}
//                           </span>
//                         </div>
//                       </div>
//                     </Chip>
//                   </div>
//                 )}

//                 {/* attachments + textarea + send */}
//                 <div className="grid grid-cols-[auto_1fr_auto] items-center">
//                   {/* attach button */}
//                   <div>
//                     <input
//                       type="file"
//                       id="file-upload"
//                       onChange={handleUpload}
//                       hidden
//                     />
//                     <label htmlFor="file-upload" className="cursor-pointer">
//                       <Button
//                         isIconOnly
//                         variant="light"
//                         className="pointer-events-none"
//                       >
//                         <ImAttachment />
//                       </Button>
//                     </label>
//                   </div>

//                   {/* textarea */}
//                   <Textarea
//                     minRows={1}
//                     maxRows={3}
//                     placeholder="Type a message"
//                     value={newMessage}
//                     onChange={(e) =>
//                       e.nativeEvent.inputType !== "insertLineBreak" &&
//                       setNewMessage(e.target.value)
//                     }
//                     onKeyDown={handleKeyDown}
//                     classNames={{ label: "hidden" }}
//                   />

//                   {/* send button */}
//                   <Button
//                     type="submit"
//                     isIconOnly
//                     variant="light"
//                     isDisabled={!newMessage && !uploadedFile}
//                   >
//                     <BiSolidPaperPlane className="text-lg" />
//                   </Button>
//                 </div>
//               </div>
//             </form>
//           </div>
//         </PopoverContent>
//       </Popover>
//     </div>
//   );
// };

// export default ChatBox;
 



import React, { useEffect, useRef, useState } from "react";
import {
  Avatar,
  Button,
  Chip,
  Textarea,
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@nextui-org/react";
import { ImAttachment } from "react-icons/im";
import { io } from "socket.io-client";
import { displayTime, formatFileSize } from "../utils";
import { FaFile } from "react-icons/fa6";
import { BiSolidPaperPlane } from "react-icons/bi";
import { IoMdChatbubbles, IoMdClose } from "react-icons/io";

const isImageFile = (fileName, dataUrl) =>
  (fileName && /\.(jpe?g|png|gif|bmp|webp|svg)$/i.test(fileName)) ||
  (dataUrl && dataUrl.startsWith("data:image"));

const ChatBox = ({ quoteId }) => {
  const accessToken = localStorage.getItem("accessToken");
  const role = localStorage.getItem("role");

  /* ---------------- state ---------------- */
  const [socket, setSocket] = useState(null);
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [prevMessages, setPrevMessages] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const [fileToUpload, setFileToUpload] = useState(""); // base64 body
  const [uploadedFile, setUploadedFile] = useState(null); // local preview
  const [imgFailed, setImgFailed] = useState({}); // { msgId: true }
  const scrollRef = useRef(null);

  /* ---------------- socket setup ---------------- */
  useEffect(() => {
    const newSocket = io(
      `${process.env.REACT_APP_SOCKET_SERVER_URL}/chats/${quoteId}`,
      { extraHeaders: { Authorization: `Bearer ${accessToken}` } }
    );
    setSocket(newSocket);

    newSocket.on("previous chat", setPrevMessages);
    newSocket.on("chat message", (m) => setPrevMessages((p) => [...p, m]));
    newSocket.on("file upload", (m) => setPrevMessages((p) => [...p, m]));

    return () => newSocket.disconnect();
  }, [accessToken, quoteId]);

  /* ---------------- always scroll to bottom ---------------- */
  useEffect(() => {
    scrollRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [prevMessages]);

  /* ---------------- send message / file ---------------- */
  const handleSendMessage = (e) => {
    e.preventDefault();

    if (newMessage.trim()) {
      socket.emit("chat message", { notes: newMessage });
      setNewMessage("");
    }

    if (fileToUpload && uploadedFile) {
      socket.emit("file upload", {
        attachments: fileToUpload,
        attachments_url: uploadedFile.filePath,
        fileName: uploadedFile.fileName,
        fileSize: uploadedFile.fileSize,
      });
      setFileToUpload("");
      setUploadedFile(null);
    }
  };

  /* ---------------- handle file select ---------------- */
  const handleUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const maxSize = 5 * 1024 * 1024; // 5 MB
    if (file.size > maxSize) {
      alert("Max 5 MB allowed");
      return (e.target.value = null);
    }

    const reader = new FileReader();
    reader.onload = (evt) =>
      setUploadedFile({
        fileName: file.name,
        fileSize: file.size,
        filePath: evt.target.result,
      });
    reader.onloadend = () => setFileToUpload(reader.result.split(",")[1]);
    reader.readAsDataURL(file);
  };

  /* ---------------- key handler (enter to send) ---------------- */
  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) handleSendMessage(e);
    if (e.key === "Enter" && e.shiftKey) setNewMessage((t) => t + "\n");
  };

  return (
    <div className="fixed bottom-20 sm:bottom-6 right-4 z-[999]">
      <Popover
        isOpen={isChatOpen}
        shouldBlockScroll
        shouldFlip={false}
        onOpenChange={setIsChatOpen}
      >
        {/* ------------- floating button ------------- */}
        <PopoverTrigger>
          <Button
            isIconOnly
            size="lg"
            className="bg-orange-100 text-orange-400 drop-shadow-md sm:drop-shadow-lg transition-transform duration-300 hover:scale-105 sm:hover:scale-110"
          >
            {isChatOpen ? (
              <IoMdClose className="text-4xl" />
            ) : (
              <IoMdChatbubbles className="text-3xl" />
            )}
          </Button>
        </PopoverTrigger>

        {/* ------------- chat panel ------------- */}
        <PopoverContent>
          <div className="w-[17rem] sm:w-96 py-2 rounded-lg max-w-lg ml-auto overflow-hidden">
            <h4 className="mb-4 font-semibold px-5">Direct messages</h4>

            {/* messages list */}
            <div className="px-5 py-6 grid bg-[#f2f3f5] max-h-[400px] overflow-y-auto">
              {prevMessages.map((item) => (
                <div
                  key={item.id}
                  ref={scrollRef}
                  className={`flex gap-3 ${
                    item.user_type === role ? "justify-end" : ""
                  } mb-5`}
                >
                  <div
                    className={`px-2.5 py-2 rounded-lg ${
                      item.user_type === role
                        ? "rounded-tr-none bg-white"
                        : "rounded-tl-none bg-gray-200"
                    }`}
                  >
                    {/* attachment (if any) */}
                    {item.attachments_url && (
                      <div className="mb-2 max-w-[250px]">
                        {!imgFailed[item.id] ? (
                          <a
                            href={item.attachments_url}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <img
                              src={item.attachments_url}
                              alt={item.fileName || "attachment"}
                              className="rounded-md object-contain"
                              onError={() =>
                                setImgFailed((p) => ({
                                  ...p,
                                  [item.id]: true,
                                }))
                              }
                            />
                          </a>
                        ) : (
                          <a
                            href={item.attachments_url}
                            target="_blank"
                            rel="noreferrer"
                            className="inline-flex items-center gap-1 px-2 py-1 text-sm bg-slate-200 rounded hover:bg-slate-300"
                          >
                            <FaFile className="text-base" />
                            Download file
                          </a>
                        )}
                      </div>
                    )}

                    {/* message text */}
                    {item.notes && <p>{item.notes}</p>}
                    <p className="text-right text-sm text-slate-500/90">
                      <sub>{displayTime(item.createdAt)}</sub>
                    </p>
                  </div>

                  {/* avatar (other side only) */}
                  <Avatar
                    className={`rounded-full ${
                      item.user_type === role ? "hidden" : "order-[-1]"
                    }`}
                  />
                </div>
              ))}
            </div>

            {/* input box + actions */}
            <form onSubmit={handleSendMessage}>
              <div className="bg-[#f2f3f5] mt-2 py-3 px-2">
                {/* local preview (if any) */}
                {uploadedFile && (
                  <div className="mb-3">
                    <Chip
                      radius="md"
                      className="px-3 py-7 bg-slate-50"
                      classNames={{
                        content: "p-0",
                        closeButton: "ml-5",
                      }}
                      onClose={() => setUploadedFile(null)}
                    >
                      <div className="flex gap-3">
                        <div className="w-12 h-12 rounded-md overflow-hidden flex items-center justify-center bg-white">
                          {isImageFile(
                            uploadedFile.fileName,
                            uploadedFile.filePath
                          ) ? (
                            <img
                              src={uploadedFile.filePath}
                              alt="preview"
                              className="w-full h-full object-cover"
                            />
                          ) : (
                            <FaFile className="text-2xl text-slate-700" />
                          )}
                        </div>
                        <div>
                          <p className="text-xs font-semibold">
                            {uploadedFile.fileName}
                          </p>
                          <span className="text-xs">
                            {formatFileSize(uploadedFile.fileSize)}
                          </span>
                        </div>
                      </div>
                    </Chip>
                  </div>
                )}

                {/* attachments + textarea + send */}
                <div className="grid grid-cols-[auto_1fr_auto] items-center">
                  {/* attach button */}
                  <div>
                    <input
                      type="file"
                      id="file-upload"
                      onChange={handleUpload}
                      hidden
                    />
                    <label htmlFor="file-upload" className="cursor-pointer">
                      <Button
                        isIconOnly
                        variant="light"
                        className="pointer-events-none"
                      >
                        <ImAttachment />
                      </Button>
                    </label>
                  </div>

                  {/* textarea */}
                  <Textarea
                    minRows={1}
                    maxRows={3}
                    placeholder="Type a message"
                    value={newMessage}
                    onChange={(e) =>
                      e.nativeEvent.inputType !== "insertLineBreak" &&
                      setNewMessage(e.target.value)
                    }
                    onKeyDown={handleKeyDown}
                    classNames={{ label: "hidden" }}
                  />

                  {/* send button */}
                  <Button
                    type="submit"
                    isIconOnly
                    variant="light"
                    isDisabled={!newMessage && !uploadedFile}
                  >
                    <BiSolidPaperPlane className="text-lg" />
                  </Button>
                </div>
              </div>
            </form>
          </div>
        </PopoverContent>
      </Popover>
    </div>
  );
};

export default ChatBox;